/* SALTY NOVA CUSTOMISATION: pairs with sections/scroll-reveal-init.liquid.
   Marks each top-level section (except the first, the hero, and this
   utility section itself) as sn-reveal, then reveals it once it enters
   the viewport. Vanilla IntersectionObserver — no dependency, no scroll
   event listeners. No-ops gracefully if IntersectionObserver is missing. */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var main = document.querySelector('main');
  if (!main) return;

  var sections = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));
  // Skip the hero (first section) so the page isn't blank on load.
  sections.shift();

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sn-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  sections.forEach(function (section) {
    if (section.classList.contains('shopify-section--scroll-reveal-init')) return;
    section.classList.add('sn-reveal');
    observer.observe(section);
  });
})();
